class Keyword {
  private element: JQuery;
  private original: string;

  constructor(element: JQuery) {
    this.element = element;
    this.original = element.val() as string;
  }

  initialize(): void {
    (this.element as any).placeholder();
  }

  isNotFound(): boolean {
    return this.element.data("notFound");
  }

  isEmpty(): boolean {
    return this.value() === "";
  }

  value(): string {
    return this.element.val() as string;
  }

  originalValue(): string {
    return this.original;
  }

  isChanged(): boolean {
    return this.value() !== this.original;
  }

  onChange(f: () => void): void {
    this.element.change(f);
  }
}

export { Keyword };
